/**
 * @return {boolean}
 */
export function isServerSide() {
    return typeof window === 'undefined';
}

/**
 * @return {boolean}
 */
export function isClientSide() {
    return !isServerSide();
}
